"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronDown(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "5 -4 14 24" }, props),
        React.createElement("path", { d: "M12 9.94L6.53 4.47a.75.75 0 00-1.06 1.06l6 6a.75.75 0 001.06 0l6-6a.75.75 0 00-1.06-1.06z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ChevronDown')(SvgChevronDown);
//# sourceMappingURL=ChevronDown.js.map